export default [{
	titulo: 'Equipamentos',
	icone: 'menu-icon fa fa-caret-right',
	url: '/sistema/equipamentos',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]